<template>
  <div style="width:100%">
    <v-autocomplete v-model="categoryId" :outlined="outlined" dense :label="label"
                    :items="[{name:noneText,id:null,level:0},{divider:true},...categories]"
                    item-text="name" item-value="id" @change="select()" :hide-details="hideDetails" :disabled="disabled"
                    :hint="hint?'To help organize your ' + type + 's':''" :persistent-hint="hint">
      <template v-slot:prepend-item v-if="allowAdd">
        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="showCreate()">
          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new category
        </div>
      </template>
      <template v-slot:item="{item}">
        <v-list-item-content :class="'pl-'+item.level*3">{{item.name}}</v-list-item-content>
      </template>
      <template v-slot:prepend>
        <slot name="prepend"/>
      </template>
    </v-autocomplete>

    <v-dialog v-model="createCategory" persistent max-width="400">
      <v-card>
        <v-card-title>Create category</v-card-title>
        <v-divider/>
          <v-form v-model="valid" immediate ref="form" class="mt-4">
            <v-container>
              <v-row dense>
                <v-col>
                  <v-text-field label="Name" v-model="category.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" outlined dense :counter="50"/>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-autocomplete v-model="category.parentId" outlined dense label="Parent"
                                  :items="[{name:noneText,id:null,level:0},{divider:true},...categories]"
                                  item-text="name" item-value="id">
                    <template v-slot:item="{item}">
                      <v-list-item-content :class="'pl-'+item.level*3">{{item.name}}</v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn plain color="primary" @click="createCategory=false">Cancel</v-btn>
          <v-btn color="primary" @click="create()" :loading="busy">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'InventoryCategoriesSelect',
  mixins: [createHierarchyList],
  props: {
    value: {required: false, type:String},
    type: {required: true, type:String},
    label: {required: false, type:String},
    allowAdd: {required: false, type:Boolean, default:false},
    name: {required: false, type:String},
    categoryList: {required: false, type:Array},
    noneText: {required: false, type:String, default:'(none)'},
    hint: {required: false, type:Boolean, default:false},
    outlined: {required: false, type:Boolean, default:true},
    hideDetails: {required: false, type:Boolean, default:false},
    disabled: {required: false, type:Boolean, default:false}
  },
  data() {
    return {
      categoryId: this.value,
      categories: [],
      createCategory: false,
      category: {},
      valid: true,
      busy: false
    }
  },
  watch: {
    value() {
      this.categoryId = this.value;
    }
  },
  async created() {
    const categories = [];
    await this.$lazyListLoad(categories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:this.type}]);
    this.buildList(categories);
    this.$emit('update:name', this.categories.find(c => c.id === this.categoryId)?.name);
  },
  methods: {
    buildList(list) {
      this.categories = this.createHierarchyList(list);
      this.$emit('update:categoryList', list);
    },
    select() {
      this.$emit('input', this.categoryId);
      this.$emit('change', this.categoryId);
      this.$emit('update:name', this.categories.find(c => c.id === this.categoryId)?.name);
    },
    showCreate() {
      this.category = {name:'', parentId:null, type:this.type};
      this.createCategory = true;
      this.$nextTick(() => this.$refs.form.validate());
    },
    async create() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.busy = true;
      const results = await this.$apiCall(`mutation InventoryCategoriesSelect($input: CategoryInput!) {
                                             categoryCreate(input:$input) {id,name,parent{id}}
                                          }`, {input:this.category});
      this.busy = false;
      if (!results.error) {
        this.categoryId = results.data.categoryCreate.id;
        this.categories.push(results.data.categoryCreate);
        this.buildList(this.categories);
        this.select();
        this.createCategory = false;
      }
    }
  }
}
</script>